export default __webpack_public_path__ + "static/media/anisha.e4e78afc.png";